/* eslint-disable no-confusing-arrow */
import styled from 'styled-components'

import { NavLink } from 'react-router-dom'

export const SidebarWrapper = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  z-index: 5;

  width: 100%;

  transition: .1s;
  max-width:  ${({ display, hovered }) => hovered && display ? '270px' : '80px'};
  height: 100vh;
  background-color: ${({ theme }) => theme.colors.background};
  border-right: ${({ display, hovered, theme }) =>
    hovered && display ? `1px ${theme.colors.borderColor}` : '1px #00000000'} solid; 
  display: flex;
`
export const SidebarMenuNav = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: flex-start;

  height: 100%;
  width: 80px; 
`

export const SidebarMenuNavList = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: flex-end;
  align-items: flex-start;

  height: 100%;
  width: 100%;
  &:first-child {
    justify-content: flex-start;
  }
  &:last-child {
    padding: 0 0 20px 0;
  }
`

export const SidebarBrand = styled.div`
  width: 100%;
  display: flex;
  justify-content: center;

  padding: 15px 0 20px 0;
  text-align: left;
`

export const SidebarBrandLogo = styled.div`
  padding: 6px 0 0 0; 
  & svg  {
    width: 60px;
  }
  & svg > path {
    fill: ${({ theme }) => theme.colors.primary};
  }
`

export const SidebarMenuNavItem = styled.div`
  padding: 0px;
  align-items: center;
  width: 100%;
  transition: 0.1s; 
`

export const SidebarMenuNavLink = styled(NavLink)`
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  gap: 8px;

  text-align: center;
  line-height: 1.2;
  font-size: 10px;
  color: ${({ theme }) => theme.colors.secondary};
  text-decoration: none;
  white-space: pre-wrap;
  padding: 8px 10px !important;

  transition: 0.3s;
  max-width: 80px;
  min-height: 80px;
  max-height: 80px;

  & > img {
    width: 25px;
    height: 25px;
  }
  & > svg {
    width: 20px;
    height: 20px;
    & path {
      stroke: ${({ theme }) => theme.colors.secondary};
    }
    & g path{
      fill: ${({ theme }) => theme.colors.secondary} !important;
    }
  } 

  &:hover {
    background-color: ${({ theme }) => theme.colors.borderColor};
    color: ${({ theme }) => theme.colors.primary};
    & div {
      font-weight: 600;
      color: ${({ theme }) => theme.colors.primary};
    }
    & path {stroke: ${({ theme }) => theme.colors.primary};}
    & g path{fill: ${({ theme }) => theme.colors.primary} !important;}
    color: ${({ theme }) => theme.colors.primary};
  }

  &.active, &.activeHover {
    & div {
      font-weight: 700;
      color: ${({ theme }) => theme.colors.primary};
    }
    & path {stroke: ${({ theme }) => theme.colors.primary};}
    & g path{fill: ${({ theme }) => theme.colors.primary} !important;}
    color: ${({ theme }) => theme.colors.primary};
    
    /* &.active {
      border-left: 6px solid ${({ theme }) => `${theme.colors.brand}`}; 
    } */
    &.activeHover {
      background-color: ${({ theme }) => theme.colors.borderColor};
    }
  }

  & > div { 
    line-height: 1.3 !important;
    color: ${({ theme }) => theme.colors.secondary};
  }
`
export const SidebarMenuNavLinkDemo = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  gap: 5px;

  text-align: center;
  line-height: 1.2;
  font-size: 10px;
  color: ${({ theme }) => theme.colors.primary};
  text-decoration: none;
  white-space: pre-wrap;

  padding: 10px 35px !important;
  transition: 0.3s;
  max-width: 80px;
  min-height: 80px;
  max-height: 80px;

  & > img {
    width: 25px;
    height: 25px;
  }
  & > svg {
    width: 20px;
    height: 20px;
    & path {
      stroke: ${({ theme }) => theme.colors.primary};
    }
  }

  // Media Query Properties
  ${({ theme }) =>
    theme.functions.mediaQuery('padding', [
      '25px 125px',
      '25px 125px',
      '25px 125px',
      '25px 125px',
      '25px 125px',
      '25px 32px',
    ])}

  &:hover {
    background-color: ${({ theme }) => theme.colors.borderColor};
    color: ${({ theme }) => theme.colors.primary};
  }

  &.active {
    font-weight: 700;
    border-left: 6px solid ${({ theme }) => `${theme.colors.brand}`};
    background-color: ${({ theme }) => theme.colors.borderColor};
  }
`

export const SidebarMenuNavText = styled.div``

export const SidebarMenuDetailed = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;

  background-color: ${({ theme }) => theme.colors.backgroundLite};

  height: 100%;
  transition: .1s;
  overflow: hidden;
  width:  ${({ hovered, display }) => hovered && display ? '190px' : '0px'};
`
